import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Ribbon, Typography } from '@tempmee/react';
import { useAppSelector } from '~/hooks/useAppSelector';
import { hideJobsInvitePopup, showJobInvitesSelectionPop } from '~/actions';
import { ConfirmPopup } from '~/commonComponents';
import {
  fireInviteRecommendationPopUpViewed,
  fireInviteRecommendationNoThanksClicked,
  fireInviteRecommendationInviteClicked,
} from '~/posthogs/events';
import AnimatedCheckCircle from './shared/AnimatedCheckCircle';

export const JobsInviteConfirmationPopup = () => {
  const dispatch = useDispatch();
  const { showConfirmation, jobIds } = useAppSelector((state) => state.multiday.jobsInvitePopup);

  useEffect(() => {
    if (showConfirmation && jobIds?.length) {
      fireInviteRecommendationPopUpViewed();
    }
  }, [showConfirmation, jobIds]);

  if (!showConfirmation || !jobIds?.length) {
    return null;
  }

  return (
    <ConfirmPopup
      dataCy="shifts-posted-success-modal"
      Icon={AnimatedCheckCircle}
      title="Shifts Posted! Let’s Get Them Filled!"
      titleStyle={{ marginTop: 14 }}
      description="Invite top professionals to help secure reliable coverage faster."
      descriptionStyle={{ width: 338, marginBottom: 24 }}
      leftButtonText="No Thanks"
      leftButtonAction={() => {
        fireInviteRecommendationNoThanksClicked();
        dispatch(hideJobsInvitePopup());
      }}
      rightButtonText="Invite Now"
      rightButtonAction={() => {
        fireInviteRecommendationInviteClicked();
        dispatch(showJobInvitesSelectionPop());
      }}
    >
      <div style={{ width: '100%', padding: '0 32px', marginBottom: 32 }}>
        <Ribbon variant="informational" data-testid="invite-recommendation-ribbon">
          Shifts with invites fill{' '}
          <Typography as="span" size="heading_4" bold color="inherit">
            2x faster
          </Typography>
          !
        </Ribbon>
      </div>
    </ConfirmPopup>
  );
};
